import React, {
  useState,
  useContext,
  useMemo,
  useCallback,
  useEffect,
} from "react";
// import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  Box,
  Paper,
  Typography,
  // Grid,
  Card,
  alpha,
  Skeleton,
  // CardContent,
  TextField,
  Button,
  IconButton,
  Chip,
  // Avatar,
  InputAdornment,
  Dialog,
  // DialogTitle,
  DialogContent,
  // DialogActions,
  // Tooltip,
  // LinearProgress,
  Alert,
  // Tabs,
  // Tab,
  // Divider,
  // Menu,
  // MenuItem,
  // Switch,
  // FormControlLabel,
  // Badge,
  // TableContainer,
  // Table,
  // TableHead,
  // TableRow,
  // TableCell,
  // TableBody,
  // CircularProgress,
  useTheme,
  // useMediaQuery,
  styled,
  // alpha
} from "@mui/material";
import {
  Search as SearchIcon,
  // FilterList as FilterIcon,
  // Print as PrintIcon,
  // Download as DownloadIcon,
  // Email as EmailIcon,
  // Phone as PhoneIcon,
  // Message as MessageIcon,
  AttachMoney as MoneyIcon,
  AccountBalance as BalanceIcon,
  Receipt as ReceiptIcon,
  // ArrowUpward as ArrowUpIcon,
  // ArrowDownward as ArrowDownIcon,
  // MoreVert as MoreVertIcon,
  // Visibility as ViewIcon,
  // Edit as EditIcon,
  // Delete as DeleteIcon,
  Payment as PaymentIcon,
  // Add as AddIcon,
  Refresh as RefreshIcon,
  // CalendarToday as CalendarIcon,
  // TrendingUp as TrendingUpIcon,
  // TrendingDown as TrendingDownIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  ArrowBack as ArrowBackIcon,
  FilterAlt as FilterAltIcon,
  Sort as SortIcon,
  Timeline as TimelineIcon,
  AccountCircle as AccountCircleIcon,
  CreditCard as CreditCardIcon,
  ReceiptLong as ReceiptLongIcon,
  Diamond as DiamondIcon,
  LocalAtm as LocalAtmIcon,
} from "@mui/icons-material";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DataContext } from "../../context/DataContext";

// Page Skeleton Component
const CustomerLedgerSkeleton = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  // Animated shimmer effect
  const ShimmerOverlay = styled(Box)(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(90deg,
      transparent 0%,
      ${alpha(isDark ? "#ffffff" : "#000000", 0.05)} 50%,
      transparent 100%)`,
    animation: "shimmer 1.2s infinite",
    "@keyframes shimmer": {
      "0%": { transform: "translateX(-100%)" },
      "100%": { transform: "translateX(100%)" },
    },
  }));

  const SkeletonCard = ({ children, height = "auto", sx = {} }) => (
    <Paper
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 3,
        mb: 2,
        background: alpha(theme.palette.background.paper, 0.6),
        backdropFilter: "blur(10px)",
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        transition: "all 0.3s ease",
        height,
        ...sx,
      }}
    >
      {children}
      <ShimmerOverlay />
    </Paper>
  );

  const SkeletonLine = ({ width = "100%", height = 20, variant = "text" }) => (
    <Skeleton
      variant={variant}
      width={width}
      height={height}
      animation="wave"
      sx={{
        bgcolor: alpha(isDark ? "#ffffff" : "#000000", 0.08),
        borderRadius: variant === "rounded" ? 2 : 1,
      }}
    />
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 2.5,
        position: "relative",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 3,
          height: "calc(100vh - 80px)",
          [theme.breakpoints.down("lg")]: {
            flexDirection: "column",
          },
        }}
      >
        {/* Customer List Sidebar Skeleton */}
        <Paper
          sx={{
            width: 400,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            borderRadius: 3,
            background: alpha(theme.palette.background.paper, 0.6),
            backdropFilter: "blur(10px)",
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            [theme.breakpoints.down("lg")]: {
              width: "100%",
              height: 400,
            },
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 2.5,
              borderBottom: `1px solid ${theme.palette.divider}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <SkeletonLine width={100} height={28} />
              <SkeletonLine variant="rounded" width={60} height={24} />
            </Box>
            <SkeletonLine variant="circular" width={32} height={32} />
          </Box>

          {/* Search Input Skeleton */}
          <Box sx={{ p: 2 }}>
            <SkeletonLine variant="rounded" height={48} width="100%" />
          </Box>

          {/* Customer List Items */}
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            {[1, 2, 3, 4, 5].map((i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                  mb: 1.5,
                  borderRadius: 2,
                  background: alpha(isDark ? "#ffffff" : "#000000", 0.05),
                }}
              >
                <SkeletonLine
                  variant="circular"
                  width={48}
                  height={48}
                  sx={{ mr: 2 }}
                />
                <Box sx={{ flex: 1 }}>
                  <SkeletonLine width={150} height={20} sx={{ mb: 1 }} />
                  <SkeletonLine width={120} height={16} sx={{ mb: 1 }} />
                  <SkeletonLine variant="rounded" width={100} height={24} />
                </Box>
              </Box>
            ))}
          </Box>
        </Paper>

        {/* Main Content Skeleton */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Header Skeleton */}
          <SkeletonCard sx={{ p: 2.25 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box>
                <SkeletonLine width={250} height={36} sx={{ mb: 0.5 }} />
                <SkeletonLine width={180} height={20} />
              </Box>
              <Box sx={{ display: "flex", gap: 2 }}>
                <SkeletonLine variant="rounded" width={100} height={40} />
                <SkeletonLine variant="rounded" width={150} height={40} />
              </Box>
            </Box>
          </SkeletonCard>

          {/* Stats Cards Grid */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: 2,
            }}
          >
            {[1, 2, 3, 4].map((i) => (
              <SkeletonCard key={i} sx={{ p: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <SkeletonLine variant="circular" width={45} height={45} />
                  <Box sx={{ flex: 1 }}>
                    <SkeletonLine width={100} height={16} sx={{ mb: 1 }} />
                    <SkeletonLine width={80} height={24} />
                  </Box>
                </Box>
              </SkeletonCard>
            ))}
          </Box>

          {/* Transactions Panel Skeleton */}
          <SkeletonCard
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 2,
                borderBottom: `1px solid ${theme.palette.divider}`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <SkeletonLine width={100} height={24} />
                <SkeletonLine width={40} height={20} />
              </Box>
              <SkeletonLine width={180} height={16} />
            </Box>

            {/* Transaction Items */}
            <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
              {[1, 2, 3].map((i) => (
                <Box
                  key={i}
                  sx={{
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    background: alpha(isDark ? "#ffffff" : "#000000", 0.05),
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1.5,
                    }}
                  >
                    <Box>
                      <SkeletonLine width={120} height={20} sx={{ mb: 0.5 }} />
                      <SkeletonLine width={100} height={16} />
                    </Box>
                    <SkeletonLine width={80} height={28} />
                  </Box>
                  <Box sx={{ mb: 1.5 }}>
                    <SkeletonLine
                      variant="rounded"
                      width={80}
                      height={24}
                      sx={{ mb: 1 }}
                    />
                    <SkeletonLine width="70%" height={16} />
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <SkeletonLine width={100} height={20} />
                    <SkeletonLine variant="rounded" width={100} height={24} />
                  </Box>
                </Box>
              ))}
            </Box>
          </SkeletonCard>
        </Box>
      </Box>
    </Box>
  );
};

// Styled components using Material-UI
const GlassCard = styled(Card)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.85)"
      : "rgba(30, 41, 59, 0.85)",
  backdropFilter: "blur(20px)",
  WebkitBackdropFilter: "blur(20px)",
  border: `1px solid ${
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.3)"
      : "rgba(148, 163, 184, 0.1)"
  }`,
  borderRadius: 20,
  boxShadow: theme.shadows[4],
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  overflow: "hidden",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      theme.palette.mode === "light"
        ? "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)"
        : "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%)",
    pointerEvents: "none",
    borderRadius: 20,
  },
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: theme.shadows[6],
    borderColor:
      theme.palette.mode === "light"
        ? "rgba(255, 255, 255, 0.5)"
        : "rgba(148, 163, 184, 0.2)",
  },
}));

const GlassPanel = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.7)"
      : "rgba(30, 41, 59, 0.7)",
  backdropFilter: "blur(40px)",
  WebkitBackdropFilter: "blur(40px)",
  border: `1px solid ${
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.3)"
      : "rgba(148, 163, 184, 0.1)"
  }`,
  borderRadius: 24,
  boxShadow: theme.shadows[4],
}));

const CustomerItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1.5),
  cursor: "pointer",
  border: `2px solid ${
    active
      ? theme.palette.mode === "light"
        ? "rgba(37, 99, 235, 0.4)"
        : "rgba(96, 165, 250, 0.4)"
      : "transparent"
  }`,
  borderRadius: 20,
  backgroundColor: active
    ? theme.palette.mode === "light"
      ? "linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(29, 78, 216, 0.05) 100%)"
      : "linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)"
    : theme.palette.mode === "light"
    ? "rgba(255, 255, 255, 0.85)"
    : "rgba(30, 41, 59, 0.85)",
  transition: "all 0.3s ease",
  "&:hover": {
    borderColor:
      theme.palette.mode === "light"
        ? "rgba(37, 99, 235, 0.2)"
        : "rgba(96, 165, 250, 0.2)",
    backgroundColor:
      theme.palette.mode === "light"
        ? "rgba(255, 255, 255, 0.95)"
        : "rgba(30, 41, 59, 0.95)",
  },
}));

const CustomerAvatar = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  background:
    theme.palette.mode === "light"
      ? "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
      : "linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.white,
  marginRight: theme.spacing(2),
  flexShrink: 0,
}));

const StatCard = styled(GlassCard)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
}));

// const StatIcon = styled(Box, {
//   shouldForwardProp: (prop) => prop !== 'colorType',
// })(({ theme, colorType }) => ({
//   width: 45,
//   height: 45,
//   borderRadius: 14,
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   color: theme.palette.common.white,
//   marginRight: theme.spacing(2),
//   flexShrink: 0,
//   boxShadow: theme.shadows[4],
//   background: colorType === 'primary'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
//       : 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)')
//     : colorType === 'success'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #34d399 0%, #10b981 100%)'
//       : 'linear-gradient(135deg, #10b981 0%, #059669 100%)')
//     : colorType === 'warning'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
//       : 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)')
//     : colorType === 'secondary'
//     ? (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)'
//       : 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)')
//     : (theme.palette.mode === 'light'
//       ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
//       : 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)'),
// }));

const TransactionItem = styled(GlassCard, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
  display: "flex",
  padding: theme.spacing(2),
  cursor: "pointer",
  border: `2px solid ${
    active
      ? theme.palette.mode === "light"
        ? "rgba(16, 185, 129, 0.4)"
        : "rgba(52, 211, 153, 0.4)"
      : "transparent"
  }`,
  transition: "all 0.3s ease",
  backgroundColor: active
    ? theme.palette.mode === "light"
      ? "linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.05) 100%)"
      : "linear-gradient(135deg, rgba(52, 211, 153, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)"
    : "inherit",
}));

const TransactionIcon = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: 12,
  background:
    theme.palette.mode === "light"
      ? "linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(29, 78, 216, 0.1) 100%)"
      : "linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.spacing(2),
  flexShrink: 0,
  border: `1px solid ${
    theme.palette.mode === "light"
      ? "rgba(59, 130, 246, 0.2)"
      : "rgba(96, 165, 250, 0.2)"
  }`,
}));

const DetailSection = styled(GlassCard, {
  shouldForwardProp: (prop) => prop !== "fullWidth",
})(({ theme, fullWidth }) => ({
  padding: theme.spacing(3),
  gridColumn: fullWidth ? "1 / -1" : "auto",
  backgroundColor:
    theme.palette.mode === "light"
      ? "rgba(160, 210, 239, 0.4)"
      : "rgba(30, 41, 59, 0.7)",
  border: `1px solid ${
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.3)"
      : "rgba(148, 163, 184, 0.2)"
  }`,
  borderRadius: 16,
  backdropFilter: "blur(10px)",
}));

const DetailContent = styled(Box)(({ theme }) => ({
  background:
    theme.palette.mode === "light"
      ? "rgba(119, 189, 219, 0.4)"
      : "rgba(30, 41, 59, 0.5)",
  padding: theme.spacing(2),
  borderRadius: 10,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
  color: theme.palette.text.primary,
}));

const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 4),
  textAlign: "center",
  color: theme.palette.text.secondary,
  background:
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(30, 41, 59, 0.3)",
  borderRadius: 20,
  border: `1px dashed ${theme.palette.divider}`,
}));

const DetailTableContainer = styled(Box)(({ theme }) => ({
  overflowX: "auto",
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
  background:
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(30, 41, 59, 0.3)",
}));

const DetailTable = styled(Box)(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  "& th": {
    padding: theme.spacing(2),
    textAlign: "left",
    fontWeight: 600,
    color: theme.palette.text.primary,
    background:
      theme.palette.mode === "light"
        ? "rgba(255, 255, 255, 0.05)"
        : "rgba(30, 41, 59, 0.3)",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "& td": {
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "& tr:hover": {
    background:
      theme.palette.mode === "light"
        ? "rgba(255, 255, 255, 0.05)"
        : "rgba(30, 41, 59, 0.3)",
  },
  "& tr.detail-table-row": {
    fontWeight: 500,
  },
  "& .amount-cell": {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
}));

const SummaryGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  gap: theme.spacing(2),
}));

const SummaryItem = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  background:
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(30, 41, 59, 0.3)",
  borderRadius: 12,
}));

const CustomerLedger = () => {
  const { customers, customerTransactions, loading, error, refresh } =
    useContext(DataContext);
  const [isPageLoading, setIsPageLoading] = useState(true);

  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // const gridRef = useRef();

  // State for UI
  const [searchQuery, setSearchQuery] = useState("");
  // const [selectCustomer, setSelectCustomer] = useState([]);
  // const [selectTransaction, setSelectTransaction] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState([]);
  // const [selectedCustomer, setSelectedCustomer] = useState(null);
  // const [viewDialogOpen, setViewDialogOpen] = useState(false);
  // const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  // const filterStatus = 'all';
  // const startDate = null;
  // const endDate = null;
  // const sortBy = 'balance';
  const [sortOrder, setSortOrder] = useState("desc");
  // const [tabValue, setTabValue] = useState(0);
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [selectedRows, setSelectedRows] = useState([]);
  // const [rowData, setRowData] = useState([]);
  // const [gridApi, setGridApi] = useState(null);
  // const [gridColumnApi, setGridColumnApi] = useState(null);
  const [transactionDetailOpen, setTransactionDetailOpen] = useState(false);
  const [selectedTransactionDetail, setSelectedTransactionDetail] =
    useState(null);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    // Only show skeleton while loading or when data is being fetched
    if (loading) {
      setIsPageLoading(true);
    } else {
      // Add a small delay for smooth transition
      const timer = setTimeout(() => {
        setIsPageLoading(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  // Also handle initial load
  useEffect(() => {
    if (!loading && customers && customerTransactions) {
      const timer = setTimeout(() => {
        setIsPageLoading(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [loading, customers, customerTransactions]);

  // Calculate customer balances from transactions
  const customersWithBalances = useMemo(() => {
    if (!customers || !customerTransactions) return [];

    return customers.map((customer) => {
      const customerTxns = customerTransactions.filter(
        (transaction) => transaction.customer === customer.id
      );

      let totalDue = 0;
      let totalPaid = 0;
      let lastTransactionDate = null;
      let overdueAmount = 0;
      let recentTransactions = [];

      customerTxns.forEach((transaction) => {
        const transactionDate = new Date(transaction.date);
        const grandTotal = transaction.summary?.grandTotal || 0;
        const paymentDone = transaction.summary?.paymentDone || 0;
        const pendingAmount = transaction.summary?.pendingAmount || 0;

        totalDue += grandTotal;
        totalPaid += paymentDone;

        if (pendingAmount > 0) {
          overdueAmount += pendingAmount;
        }

        if (!lastTransactionDate || transactionDate > lastTransactionDate) {
          lastTransactionDate = transactionDate;
        }

        recentTransactions.push({
          id: transaction.id,
          date: transaction.date,
          billNo: transaction.transactionDetails?.billNo || "N/A",
          amount: grandTotal,
          paid: paymentDone,
          pending: pendingAmount,
          type: transaction.transactionDetails?.type || "detailed",
          gst: transaction.transactionDetails?.gstApplicable || false,
        });
      });

      recentTransactions?.sort((a, b) => {
        if (a.timestamp && b.timestamp) {
          return b.timestamp - a.timestamp;
        }
        if (a.createdAt && b.createdAt) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        }
        return new Date(b.date) - new Date(a.date);
      });

      const balance = totalDue - totalPaid;
      const daysOverdue = lastTransactionDate
        ? Math.floor((new Date() - lastTransactionDate) / (1000 * 60 * 60 * 24))
        : 0;

      return {
        ...customer,
        id: customer.id,
        customerId: customer.id,
        totalTransactions: customerTxns.length,
        totalDue,
        totalPaid,
        balance,
        overdueAmount,
        lastTransactionDate,
        daysOverdue,
        recentTransactions: recentTransactions.slice(0, 5),
        status: balance > 0 ? (balance > 10000 ? "high" : "medium") : "paid",
      };
    });
  }, [customers, customerTransactions]);

  const getCustomersWithPendingPayments = useCallback(() => {
    if (!customers || !customerTransactions) return [];

    return customers.filter((customer) => {
      const customerTrans = customerTransactions.filter(
        (t) => t.customer === customer.id
      );
      return customerTrans.some((t) => t.summary?.pendingAmount > 0);
    });
  }, [customers, customerTransactions]);

  // Get customers with pending payments - memoized
  const customersWithPendingPayments = useMemo(() => {
    const pendingCustomers = getCustomersWithPendingPayments();
    return pendingCustomers.map((customer) => {
      const customerData = customersWithBalances.find(
        (c) => c.id === customer.id
      );
      return customerData || customer;
    });
  }, [getCustomersWithPendingPayments, customersWithBalances]);

  // Filter customers based on search and filters
  // const filteredCustomers = useMemo(() => {
  //   let filtered = customersWithPendingPayments;

  //   if (searchQuery) {
  //     const query = searchQuery.toLowerCase();
  //     filtered = filtered.filter(customer =>
  //       customer.name?.toLowerCase().includes(query) ||
  //       customer.contact.toString()?.toLowerCase().includes(query) ||
  //       customer.address?.toLowerCase().includes(query)
  //     );
  //   }

  //   if (filterStatus !== 'all') {
  //     switch (filterStatus) {
  //       case 'overdue':
  //         filtered = filtered.filter(customer => customer.daysOverdue > 30);
  //         break;
  //       case 'high':
  //         filtered = filtered.filter(customer => customer.balance > 10000);
  //         break;
  //       case 'recent':
  //         filtered = filtered.filter(customer => customer.daysOverdue <= 7);
  //         break;
  //     }
  //   }

  //   if (startDate && endDate) {
  //     filtered = filtered.filter(customer => {
  //       if (!customer.lastTransactionDate) return true;
  //       const transDate = new Date(customer.lastTransactionDate);
  //       return transDate >= startDate && transDate <= endDate;
  //     });
  //   }

  //   filtered?.sort((a, b) => {
  //     let aValue, bValue;

  //     switch (sortBy) {
  //       case 'balance':
  //         aValue = a.balance;
  //         bValue = b.balance;
  //         break;
  //       case 'name':
  //         aValue = a.name?.toLowerCase();
  //         bValue = b.name?.toLowerCase();
  //         break;
  //       case 'overdue':
  //         aValue = a.daysOverdue;
  //         bValue = b.daysOverdue;
  //         break;
  //       case 'lastPayment':
  //         aValue = a.lastTransactionDate ? new Date(a.lastTransactionDate) : new Date(0);
  //         bValue = b.lastTransactionDate ? new Date(b.lastTransactionDate) : new Date(0);
  //         break;
  //       default:
  //         aValue = a.balance;
  //         bValue = b.balance;
  //     }

  //     if (sortOrder === 'desc') {
  //       return bValue - aValue;
  //     } else {
  //       return aValue - bValue;
  //     }
  //   });

  //   return filtered;
  // }, [customersWithPendingPayments, searchQuery, filterStatus, startDate, endDate, sortBy, sortOrder]);

  // Calculate summary statistics
  // const summaryStats = useMemo(() => {
  //   const totalBalance = filteredCustomers.reduce((sum, customer) => sum + customer.balance, 0);
  //   const totalOverdue = filteredCustomers.reduce((sum, customer) => sum + customer.overdueAmount, 0);
  //   const totalCustomers = filteredCustomers.length;
  //   const averageBalance = totalCustomers > 0 ? totalBalance / totalCustomers : 0;

  //   return {
  //     totalBalance,
  //     totalOverdue,
  //     totalCustomers,
  //     averageBalance
  //   };
  // }, [filteredCustomers]);

  // Get selected customer details
  const selectedCustomerDetails = useMemo(() => {
    return customersWithBalances.find((c) => c.id === selectedCustomerId);
  }, [selectedCustomerId, customersWithBalances]);

  // Get transactions for selected customer
  const selectedCustomerTransactions = useMemo(() => {
    if (!selectedCustomerId) return [];

    const transactions = customerTransactions.filter(
      (t) => t.customer === selectedCustomerId
    );

    return transactions.sort((a, b) => {
      if (a.timestamp && b.timestamp) {
        return b.timestamp - a.timestamp;
      }
      if (a.createdAt && b.createdAt) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      if (a.transactionTime && b.transactionTime) {
        const dateTimeA = new Date(`${a.date} ${a.transactionTime}`);
        const dateTimeB = new Date(`${b.date} ${b.transactionTime}`);
        return dateTimeB - dateTimeA;
      }
      try {
        const dateA = new Date(a.date.split("/").reverse().join("-"));
        const dateB = new Date(b.date.split("/").reverse().join("-"));
        return dateB - dateA;
      } catch {
        return 0;
      }
    });
  }, [selectedCustomerId, customerTransactions]);

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  // Handle view transaction detail
  const handleViewTransactionDetail = useCallback(
    (transactionId) => {
      const transaction = customerTransactions.find(
        (t) => t.id === transactionId
      );
      if (transaction) {
        setSelectedTransactionDetail(transaction);
        setTransactionDetailOpen(true);
        // setSelectTransaction(transactionId);
      }
    },
    [customerTransactions]
  );

  // Render customer list sidebar
  const renderCustomerList = () => {
    if (customersWithPendingPayments.length === 0) {
      return (
        <EmptyState>
          <DiamondIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          {loading
            ? "Loading customers..."
            : "No customers with pending payments"}
        </EmptyState>
      );
    }

    const filtered = customersWithPendingPayments.filter((customer) => {
      const name = (customer.name || "Unknown Customer").toLowerCase();
      return name.includes(searchQuery.toLowerCase());
    });

    if (filtered.length === 0) {
      return (
        <EmptyState>
          <SearchIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          No customers match your search
        </EmptyState>
      );
    }

    return filtered.map((customer) => {
      const customerTxns = customerTransactions.filter(
        (t) => t.customer === customer.id
      );
      let totalPending = customerTxns.reduce(
        (sum, t) => sum + (t.summary ? t.summary.pendingAmount : 0),
        0
      );
      totalPending = totalPending + customer?.openingBalance || 0;

      return (
        <CustomerItem
          key={customer.id}
          active={selectedCustomerId === customer.id}
          onClick={() => setSelectedCustomerId(customer.id)}
        >
          <CustomerAvatar>
            <AccountCircleIcon />
          </CustomerAvatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, color: "text.primary" }}
              >
                {customer.name || "Unknown Customer"}
              </Typography>
              <Chip
                label={`${customerTxns.length} txn`}
                size="small"
                sx={{
                  fontSize: 11,
                  height: 20,
                  bgcolor:
                    theme.palette.mode === "light"
                      ? "rgba(37, 99, 235, 0.1)"
                      : "rgba(96, 165, 250, 0.1)",
                  color: "primary.main",
                  fontWeight: 600,
                }}
              />
            </Box>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
              {customer.contact || "No contact"}
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Chip
                icon={<CreditCardIcon />}
                label={formatCurrency(totalPending)}
                size="small"
                sx={{
                  bgcolor:
                    theme.palette.mode === "light"
                      ? "rgba(59, 130, 246, 0.1)"
                      : "rgba(96, 165, 250, 0.1)",
                  border: `1px solid ${
                    theme.palette.mode === "light"
                      ? "rgba(59, 130, 246, 0.2)"
                      : "rgba(96, 165, 250, 0.2)"
                  }`,
                  color: "text.primary",
                  fontWeight: 600,
                }}
              />
            </Box>
          </Box>
        </CustomerItem>
      );
    });
  };

  // Render transaction list for selected customer
  const renderTransactionList = () => {
    if (!selectedCustomerId) {
      return (
        <EmptyState>
          <ReceiptLongIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          Select a customer to view transactions
        </EmptyState>
      );
    }

    if (selectedCustomerTransactions.length === 0) {
      return (
        <EmptyState>
          <ReceiptIcon sx={{ fontSize: 56, mb: 2, opacity: 0.5 }} />
          No transactions found
        </EmptyState>
      );
    }

    return selectedCustomerTransactions.map((transaction) => {
      const date = transaction.date || "Unknown Date";
      const grandTotal = transaction.summary
        ? transaction.summary.grandTotal
        : 0;
      const paymentDone = transaction.summary
        ? transaction.summary.paymentDone
        : 0;
      const pendingAmount = transaction.summary
        ? transaction.summary.pendingAmount
        : 0;
      const billNo = transaction.transactionDetails
        ? transaction.transactionDetails.billNo
        : "N/A";
      const items = transaction.items
        ? transaction.items.map((item) => item.name).join(", ")
        : "No items";

      return (
        <TransactionItem
          key={transaction.id}
          active={selectedTransactionDetail?.id === transaction.id}
          onClick={() => handleViewTransactionDetail(transaction.id)}
        >
          <TransactionIcon>
            {pendingAmount > 0 ? (
              <WarningIcon color="warning" sx={{ fontSize: 24 }} />
            ) : (
              <CheckCircleIcon color="success" sx={{ fontSize: 24 }} />
            )}
          </TransactionIcon>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 1.5,
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
                  Bill #{billNo}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", fontWeight: 500 }}
                >
                  {date}
                </Typography>
              </Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "text.primary" }}
              >
                {formatCurrency(grandTotal)}
              </Typography>
            </Box>
            <Box
              sx={{ mb: 1.5, display: "flex", alignItems: "center", gap: 1.5 }}
            >
              <Chip
                label={pendingAmount > 0 ? "Pending" : "Paid"}
                size="small"
                sx={{
                  bgcolor: pendingAmount > 0 ? "warning.main" : "success.main",
                  color: "white",
                  fontWeight: 600,
                  fontSize: 12,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {items}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <LocalAtmIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "text.secondary" }}
                >
                  {formatCurrency(paymentDone)}
                </Typography>
              </Box>
              {pendingAmount > 0 && (
                <Chip
                  icon={<WarningIcon />}
                  label={`${formatCurrency(pendingAmount)} pending`}
                  size="small"
                  sx={{
                    bgcolor: "warning.main",
                    color: "white",
                    fontWeight: 600,
                    fontSize: 12,
                  }}
                />
              )}
            </Box>
          </Box>
        </TransactionItem>
      );
    });
  };

  // Render stats cards for selected customer
  const renderStatsCards = () => {
    if (!selectedCustomerDetails) return null;

    const openingBalance = selectedCustomerDetails.openingBalance || 0;
    const totalBuying = selectedCustomerDetails.totalDue || 0;
    const totalPaid = selectedCustomerDetails.totalPaid || 0;
    const totalDiscount = selectedCustomerTransactions.reduce(
      (sum, t) => sum + (t.paymentDetails ? t.paymentDetails.discount : 0),
      0
    );
    const totalPending = selectedCustomerDetails.balance + openingBalance;

    const stats = [
      {
        label: "Opening Balance",
        value: openingBalance,
        icon: <TimelineIcon />,
        colorType: "primary",
      },
      {
        label: "Total Supplied",
        value: totalBuying,
        icon: <TimelineIcon />,
        colorType: "primary",
      },
      {
        label: "Total Discount",
        value: totalDiscount,
        icon: <MoneyIcon />,
        colorType: "secondary",
      },
      {
        label: "Total Received",
        value: totalPaid,
        icon: <BalanceIcon />,
        colorType: "success",
      },
      {
        label: "Pending Payment",
        value: totalPending,
        icon: <PaymentIcon />,
        colorType: "warning",
      },
    ];

    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
          gap: 1,
        }}
      >
        {stats.map((stat, index) => (
          <StatCard key={index}>
            {/* <StatIcon colorType={stat.colorType}>
              {stat.icon}
            </StatIcon> */}
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "text.secondary",
                  mb: 0.5,
                  display: "block",
                }}
              >
                {stat.label}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "text.primary",
                }}
              >
                {formatCurrency(stat.value)}
              </Typography>
            </Box>
          </StatCard>
        ))}
      </Box>
    );
  };

  // Render transaction detail view
  const renderTransactionDetail = () => {
    if (!selectedTransactionDetail) return null;

    const transaction = selectedTransactionDetail;
    const customer = customers.find((c) => c.id === transaction.customer) || {};
    const items = transaction.items || [];
    const calculatedTotals = transaction.calculatedTotals || {};
    const paymentDetails = transaction.paymentDetails || {};
    const summary = transaction.summary || {};
    const transactionDetails = transaction.transactionDetails || {};
    return (
      <GlassPanel sx={{ p: 4, maxHeight: "85vh", overflowY: "auto" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => setTransactionDetailOpen(false)}
            sx={{
              borderRadius: 12,
              padding: "10px 24px",
              bgcolor:
                theme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.85)"
                  : "rgba(30, 41, 59, 0.85)",
              border: `1px solid ${
                theme.palette.mode === "light"
                  ? "rgba(255, 255, 255, 0.3)"
                  : "rgba(148, 163, 184, 0.1)"
              }`,
              color: "text.primary",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                bgcolor:
                  theme.palette.mode === "light"
                    ? "rgba(37, 99, 235, 0.1)"
                    : "rgba(96, 165, 250, 0.1)",
                borderColor:
                  theme.palette.mode === "light"
                    ? "rgba(37, 99, 235, 0.3)"
                    : "rgba(96, 165, 250, 0.3)",
              },
            }}
          >
            Back to transactions
          </Button>
          <Chip
            label={summary.pendingAmount > 0 ? "PENDING" : "PAID"}
            sx={{
              fontWeight: 600,
              letterSpacing: 0.5,
              padding: "8px 20px",
              fontSize: 13,
              height: 32,
              bgcolor:
                summary.pendingAmount > 0 ? "warning.main" : "success.main",
              color: "white",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 3,
          }}
        >
          {/* Customer Details */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 3,
                color: "text.primary",
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <AccountCircleIcon /> Customer Details
            </Typography>
            <DetailContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                >
                  Name
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: "text.primary" }}
                >
                  {customer.name || "Unknown"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                >
                  Contact
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: "text.primary" }}
                >
                  {customer.contact || "N/A"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                >
                  Address
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: "text.primary" }}
                >
                  {customer.address || "N/A"}
                </Typography>
              </Box>
            </DetailContent>
          </DetailSection>

          {/* Transaction Details */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 3,
                color: "text.primary",
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <ReceiptIcon /> Transaction Details
            </Typography>
            <DetailContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                >
                  Date
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: "text.primary" }}
                >
                  {transaction.date || "N/A"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 1,
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                >
                  Bill No
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 600, color: "text.primary" }}
                >
                  {transactionDetails.billNo || "N/A"}
                </Typography>
              </Box>
            </DetailContent>
          </DetailSection>

          {/* Items Table */}
          <DetailSection fullWidth>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 3,
                color: "text.primary",
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <DiamondIcon /> Items ({items.length})
            </Typography>
            {items.length ? (
              <DetailTableContainer>
                <DetailTable component="table">
                  <Box component="thead">
                    <Box component="tr">
                      {[
                        "Item #",
                        "Name",
                        "HUID",
                        "Weight",
                        "Rate",
                        "Total",
                      ].map((header) => (
                        <Box component="th" key={header}>
                          {header}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                  <Box component="tbody">
                    {items.map((item) => (
                      <Box
                        component="tr"
                        key={item.itemNumber}
                        className="detail-table-row"
                      >
                        <Box component="td">{item.itemNumber || "-"}</Box>
                        <Box component="td">{item.name || "-"}</Box>
                        <Box component="td">{item.huid || "-"}</Box>
                        <Box component="td">{item.weight || "-"}</Box>
                        <Box component="td">{item.metalRate || "-"}</Box>
                        <Box component="td" className="amount-cell">
                          {formatCurrency(item.total || 0)}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </DetailTable>
              </DetailTableContainer>
            ) : (
              <EmptyState>No items found</EmptyState>
            )}
          </DetailSection>

          {/* Payment Summary */}
          <DetailSection fullWidth>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 3,
                color: "text.primary",
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <BalanceIcon /> Payment Summary
            </Typography>
            <SummaryGrid>
              <SummaryItem>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Subtotal
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "text.primary" }}
                >
                  {formatCurrency(calculatedTotals.subtotal || 0)}
                </Typography>
              </SummaryItem>
              {summary?.cgst !== 0 && (
                <>
                  <SummaryItem>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      CGST (1.5%)
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "text.primary" }}
                    >
                      {formatCurrency(summary.cgst || 0)}
                    </Typography>
                  </SummaryItem>
                  <SummaryItem>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      SGST (1.5%)
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "text.primary" }}
                    >
                      {formatCurrency(summary.sgst || 0)}
                    </Typography>
                  </SummaryItem>
                </>
              )}
              <SummaryItem>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Grand Total
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "text.primary" }}
                >
                  {summary?.cgst === 0
                    ? formatCurrency(
                        parseInt(parseFloat(summary.grandTotal).toFixed(2)) +
                          parseInt(parseFloat(paymentDetails?.discount))
                      )
                    : formatCurrency(summary.grandTotal || 0)}
                </Typography>
              </SummaryItem>
              <SummaryItem>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Payment Done
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "success.main" }}
                >
                  {formatCurrency(summary.paymentDone || 0)}
                </Typography>
              </SummaryItem>
              <SummaryItem>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Pending Amount
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "warning.main" }}
                >
                  {formatCurrency(summary.pendingAmount || 0)}
                </Typography>
              </SummaryItem>
            </SummaryGrid>
          </DetailSection>

          {/* Payment Breakdown */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 3,
                color: "text.primary",
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <CreditCardIcon /> Payment Breakdown
            </Typography>
            <DetailContent>
              {[
                { label: "Cash", value: paymentDetails.cash },
                { label: "Online", value: paymentDetails.online },
                { label: "Cheque", value: paymentDetails.cheque },
                { label: "Discount", value: paymentDetails.discount },
                { label: "Other", value: paymentDetails.other },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    {formatCurrency(item.value || 0)}
                  </Typography>
                </Box>
              ))}
            </DetailContent>
          </DetailSection>

          {/* Advance Payments */}
          <DetailSection>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 3,
                color: "text.primary",
                pb: 2,
                borderBottom: `2px solid ${theme.palette.divider}`,
              }}
            >
              <LocalAtmIcon /> Advance Payments
            </Typography>
            <DetailContent>
              {[
                {
                  label: "Advance Cash",
                  value: paymentDetails?.advancePayment?.breakup?.cash,
                },
                {
                  label: "Advance Online",
                  value: paymentDetails?.advancePayment?.breakup?.online,
                },
                {
                  label: "Advance Old Gold",
                  value: paymentDetails?.advancePayment?.breakup?.oldGold,
                },
                {
                  label: "Advance Old Silver",
                  value: paymentDetails?.advancePayment?.breakup?.oldSilver,
                },
                {
                  label: "Advance Other",
                  value: paymentDetails?.advancePayment?.breakup?.custom,
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: "text.secondary", fontWeight: 500, pr: 2 }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    {formatCurrency(item.value || 0)}
                  </Typography>
                </Box>
              ))}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 2,
                  mt: 1,
                  borderTop: `2px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ color: "text.primary", fontWeight: 700 }}
                >
                  Total Advance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, color: "success.main" }}
                >
                  {formatCurrency(paymentDetails?.advancePayment?.total || 0)}
                </Typography>
              </Box>
            </DetailContent>
          </DetailSection>
        </Box>
      </GlassPanel>
    );
  };

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          gap: 3,
          p: 3,
        }}
      >
        <Alert
          severity="error"
          sx={{
            bgcolor:
              theme.palette.mode === "light"
                ? "rgba(255, 255, 255, 0.85)"
                : "rgba(30, 41, 59, 0.85)",
            backdropFilter: "blur(20px)",
            border: `1px solid ${
              theme.palette.mode === "light"
                ? "rgba(255, 255, 255, 0.3)"
                : "rgba(148, 163, 184, 0.1)"
            }`,
            borderRadius: 20,
          }}
        >
          Error loading data: {error}
        </Alert>
        <Button
          variant="contained"
          onClick={refresh}
          startIcon={<RefreshIcon />}
          sx={{
            borderRadius: 12,
            background:
              theme.palette.mode === "light"
                ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            color: "white",
            fontWeight: 600,
            padding: "12px 32px",
            boxShadow: theme.shadows[4],
          }}
        >
          Retry Loading Data
        </Button>
      </Box>
    );
  }

  return (
    <>
      {isPageLoading ? (
        <CustomerLedgerSkeleton />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            sx={{
              minHeight: "100vh",
              p: 2.5,
              position: "relative",
              overflowX: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage:
                  theme.palette.mode === "light"
                    ? `radial-gradient(circle at 20% 80%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
               radial-gradient(circle at 80% 20%, rgba(59, 130, 246, 0.15) 0%, transparent 50%)`
                    : `radial-gradient(circle at 20% 80%, rgba(139, 92, 246, 0.15) 0%, transparent 50%),
               radial-gradient(circle at 80% 20%, rgba(96, 165, 250, 0.15) 0%, transparent 50%)`,
                zIndex: -1,
                pointerEvents: "none",
              },
            }}
          >
            {/* Main Layout */}
            <Box
              sx={{
                display: "flex",
                gap: 3,
                height: "calc(100vh - 80px)",
                [theme.breakpoints.down("lg")]: {
                  flexDirection: "column",
                },
              }}
            >
              {/* Customer List Sidebar */}
              <GlassPanel
                sx={{
                  width: 400,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  [theme.breakpoints.down("lg")]: {
                    width: "100%",
                    height: 400,
                  },
                }}
              >
                <Box
                  sx={{
                    p: 2.5,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, color: "text.primary" }}
                    >
                      Customers
                    </Typography>
                    <Chip
                      label={`${customersWithPendingPayments.length} pending`}
                      size="small"
                      sx={{
                        fontWeight: 500,
                        bgcolor: "warning.main",
                        color: "white",
                      }}
                    />
                  </Box>
                  <IconButton
                    size="small"
                    onClick={() => setShowFilters(!showFilters)}
                    sx={{
                      bgcolor: showFilters
                        ? theme.palette.mode === "light"
                          ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                          : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
                        : theme.palette.mode === "light"
                        ? "rgba(255, 255, 255, 0.85)"
                        : "rgba(30, 41, 59, 0.85)",
                      border: `1px solid ${
                        theme.palette.mode === "light"
                          ? "rgba(255, 255, 255, 0.3)"
                          : "rgba(148, 163, 184, 0.1)"
                      }`,
                      color: showFilters ? "Blue" : "Grey",
                    }}
                  >
                    <FilterAltIcon />
                  </IconButton>
                </Box>

                {showFilters && (
                  <GlassCard sx={{ m: 2, p: 2 }}>
                    <Box sx={{ mb: 1.5 }}>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Search customers..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 12,
                            background:
                              theme.palette.mode === "light"
                                ? "rgba(255, 255, 255, 0.05)"
                                : "rgba(30, 41, 59, 0.3)",
                            transition: "all 0.3s ease",
                            color: "text.primary",
                            "&:hover": {
                              background:
                                theme.palette.mode === "light"
                                  ? "rgba(255, 255, 255, 0.1)"
                                  : "rgba(30, 41, 59, 0.4)",
                            },
                            "&.Mui-focused": {
                              background:
                                theme.palette.mode === "light"
                                  ? "rgba(255, 255, 255, 0.15)"
                                  : "rgba(30, 41, 59, 0.5)",
                              boxShadow: `0 0 0 3px ${
                                theme.palette.mode === "light"
                                  ? "rgba(16, 185, 129, 0.1)"
                                  : "rgba(59, 130, 246, 0.1)"
                              }`,
                            },
                          },
                          "& .MuiInputBase-input": {
                            color: "text.primary !important",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: `${theme.palette.divider} !important`,
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon sx={{ color: "text.secondary" }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <Button
                      fullWidth
                      size="small"
                      startIcon={<SortIcon />}
                      onClick={() =>
                        setSortOrder(sortOrder === "desc" ? "asc" : "desc")
                      }
                      sx={{
                        borderRadius: 12,
                        border: `1px solid ${theme.palette.divider}`,
                        color: "text.primary",
                        bgcolor:
                          theme.palette.mode === "light"
                            ? "rgba(255, 255, 255, 0.05)"
                            : "rgba(30, 41, 59, 0.3)",
                        "&:hover": {
                          bgcolor:
                            theme.palette.mode === "light"
                              ? "rgba(255, 255, 255, 0.1)"
                              : "rgba(30, 41, 59, 0.4)",
                        },
                      }}
                    >
                      Sort:{" "}
                      {sortOrder === "desc" ? "High to Low" : "Low to High"}
                    </Button>
                  </GlassCard>
                )}

                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 2,
                  }}
                >
                  {renderCustomerList()}
                </Box>
              </GlassPanel>

              {/* Main Content */}
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                {/* Header */}
                <GlassPanel sx={{ p: 2.25 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: 700,
                          mb: 0.5,
                          background:
                            theme.palette.mode === "light"
                              ? "linear-gradient(135deg, #2d3748 0%, #4a5568 100%)"
                              : "linear-gradient(135deg, #f1f5f9 0%, #cbd5e1 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          backgroundClip: "text",
                        }}
                      >
                        Customer Ledger
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        Manage customer balances and transactions
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                      <Button
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        onClick={refresh}
                        sx={{
                          borderRadius: 12,
                          border: `1px solid ${theme.palette.divider}`,
                          color: "text.primary",
                          bgcolor:
                            theme.palette.mode === "light"
                              ? "rgba(255, 255, 255, 0.85)"
                              : "rgba(30, 41, 59, 0.85)",
                          "&:hover": {
                            bgcolor:
                              theme.palette.mode === "light"
                                ? "rgba(16, 185, 129, 0.1)"
                                : "rgba(59, 130, 246, 0.1)",
                            borderColor:
                              theme.palette.mode === "light"
                                ? "rgba(16, 185, 129, 0.3)"
                                : "rgba(59, 130, 246, 0.3)",
                          },
                        }}
                      >
                        Refresh
                      </Button>
                      {selectedCustomerDetails && (
                        <Chip
                          icon={<AccountCircleIcon />}
                          label={
                            selectedCustomerDetails.name || "Select Customer"
                          }
                          sx={{
                            background:
                              theme.palette.mode === "light"
                                ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                                : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                            color: "white",
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </GlassPanel>

                {/* Stats Cards */}
                <Box>{renderStatsCards()}</Box>

                {/* Transaction List */}
                <GlassPanel
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      p: 1.5,
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 600, color: "text.primary" }}
                        >
                          Transactions
                        </Typography>
                        {selectedCustomerDetails && (
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                          >
                            ({selectedCustomerTransactions.length})
                          </Typography>
                        )}
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{ color: "text.secondary" }}
                      >
                        Click on transaction to view details
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      overflowY: "auto",
                      p: 2,
                    }}
                  >
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      {renderTransactionList()}
                    </Box>
                  </Box>
                </GlassPanel>
              </Box>
            </Box>

            {/* Transaction Detail Dialog */}
            <Dialog
              open={transactionDetailOpen}
              onClose={() => setTransactionDetailOpen(false)}
              maxWidth="lg"
              fullWidth
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  overflow: "hidden",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  maxHeight: "90vh",
                },
              }}
            >
              <DialogContent sx={{ p: 0, backgroundColor: "transparent" }}>
                {renderTransactionDetail()}
              </DialogContent>
            </Dialog>

            {/* Scrollbar Styling */}
            <style>{`
          ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }

          ::-webkit-scrollbar-track {
            background: transparent;
          }

          ::-webkit-scrollbar-thumb {
            background: ${theme.palette.divider};
            border-radius: 4px;
          }

          ::-webkit-scrollbar-thumb:hover {
            background: ${theme.palette.text.secondary};
          }
        `}</style>
          </Box>
        </LocalizationProvider>
      )}
    </>
  );
};

export default CustomerLedger;
